import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import { Link } from 'react-router-dom';
import noDataImage from "../assets/nodata.png";
import 'react-quill/dist/quill.snow.css';
import Swal from 'sweetalert2';
import SuperAdminSideNavbar from './helpers/superadminSideNavbar';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faIdBadge, faUser} from '@fortawesome/free-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
const ListOfUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRole, setSelectedRole] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const usersPerPage = 9;

  const roleMapping = {
    1: 'Personal Branding',
    2: 'Business Branding',
    4: 'Agency'
  };

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallusersandadmins`);
        setUsers(response.data.filter((x) => x.RoleID !== 3));
      } catch (error) {
        console.error('Error fetching users:', error);
      }
      setLoading(false);
    };

    fetchUsers();
  }, []);

  const handleRoleChange = (e) => {
    setSelectedRole(e.target.value);
    setCurrentPage(0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
    setCurrentPage(0);
  };

  const filteredUsers = users
    .filter(user => selectedRole === 'All' || user.RoleID === parseInt(selectedRole))
    .filter(user =>
      user.UserName.toLowerCase().includes(searchTerm) ||
      user.Email.toLowerCase().includes(searchTerm)
    );

  const pageCount = Math.ceil(filteredUsers.length / usersPerPage);
  const offset = currentPage * usersPerPage;
  const currentUsers = filteredUsers.slice(offset, offset + usersPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const toggleUserStatus = async (user) => {
    const updatedStatus = !user.IsActive;
    try {
      const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/updateuserstatus`, {
        UserID: user.UserID,
        IsActive: updatedStatus,
        Email:user.Email
      });

      if (response.data.message === 'User status updated successfully') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Done',
          showConfirmButton: false,
          timer: 3000
        });
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error updating status!',
          showConfirmButton: false,
          timer: 3000
        });
      }

      setUsers(users?.map(u => u.UserID === user.UserID ? { ...u, IsActive: updatedStatus } : u));
    } catch (error) {
      console.error('Error updating user status:', error);
    }
  };

  return (
    <SuperAdminSideNavbar>
      <div className="card shadow-sm p-3" style={{ border: 'none', backgroundColor: '#fff' }}>
      <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2" style={{ border: 'none', backgroundColor: '#fff' }}>
  <h5 className="welcome-text mb-0" style={{ fontSize: '20px', color: '#2e3192' }}>Users List</h5>

  <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2">
  <select
    className="form-control w-100 w-sm-auto"
    value={selectedRole}
    onChange={handleRoleChange}
  >
    <option value="All">All Roles</option>
    <option value="1">User</option>
    <option value="2">Admin</option>
    <option value="4">Page</option>
  </select>

  <input
    type="text"
    className="form-control w-100 w-sm-auto"
    placeholder="Search by Name or Email"
    value={searchTerm}
    onChange={handleSearchChange}
  />
</div>

</div>

        <hr />
        <div className="container mt-5">
          {loading ? (
            <div className="spinner"></div>
          ) : filteredUsers.length === 0 ? (
            <div style={{ textAlign: 'center' }}>
              <img src={noDataImage} alt="No Data" style={{ width: '50%' }} />
              <p style={{ color: '#2e3192', fontSize: '20px' }}>No users found</p>
            </div>
          ) : (
            <>
              <div className="row">
              {currentUsers.map((user) => (
  <div key={user.UserID} className="col-md-4 mb-4">
    <div className="card">
      <div className="card-body">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-username-${user.UserID}`}>User Name</Tooltip>}
        >
          <p className="card-text">
            <FontAwesomeIcon icon={faUser} className="me-2" style={{ color: '#2E3192' }} />
            {user.UserName}
          </p>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-email-${user.UserID}`}>Email</Tooltip>}
        >
          <p className="card-text">
            <FontAwesomeIcon icon={faEnvelope} className="me-2" style={{ color: '#2E3192' }} />
            {user.Email}
          </p>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-role-${user.UserID}`}>Role</Tooltip>}
        >
          <p className="card-text">
            <FontAwesomeIcon icon={faIdBadge} className="me-2" style={{ color: '#2E3192' }} />
           {roleMapping[user.RoleID] || 'Unknown'}
          </p>
        </OverlayTrigger>
      </div>

      <div className="card-footer text-center">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-status-${user.UserID}`}>
            {user.IsActive ? 'Deactivate User' : 'Activate User'}
          </Tooltip>}
        >
            <button
                        className={`btn btn-${user.IsActive ?  'success' : 'danger'}`}
                        onClick={() => toggleUserStatus(user)}
                      >
                        <i className={`fa fa-${user.IsActive ? 'toggle-on' : 'toggle-off'}`} aria-hidden="true" style={{ fontSize: 20, color: user.IsActive ? "#fff" : "#d9534f" }}></i>
                      </button>
        </OverlayTrigger>
      </div>
    </div>
  </div>
))}

              </div>
              <div className="d-flex justify-content-center mt-4">
                <ReactPaginate
                  previousLabel={"← Previous"}
                  nextLabel={"Next →"}
                  breakLabel={"..."}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </SuperAdminSideNavbar>
  );
};

export default ListOfUsers;
